/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_COMPARACION,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {VISIBILIDADMOVIMIENTO} from "../../Constantes";
import Dialogo_Retiro from "../Dialogos/Dialogo_Retiro";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {where} from "firebase/firestore";


const Seccion_Retiros = () => {
    const [wheres, setWheres] = useState(
        [
            where('tipo', 'in', ['Bono', 'Rendimientos']),
            where('valor', '<', 0),
            where('estado', '==', 'Validando'),
        ]);
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'movimientos', wheres: wheres});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Retiro,
        titulo: 'Detalles del Retiro',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista retiros por validar'}
                        descripcion={`${numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        // clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Retiros

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: '# y tipo',
        direccion: 'left',
        propiedades: ['consecutivo', 'tipo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        titulo: "correo",
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Metodo y Valor',
        direccion: 'left',
        propiedad: 'valor',
        titulo: 'metodo',
        siTitulo: 'puntos',
        tipo: CASILLA_COMPARACION

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',
        titulo: 'realizador',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Visibilidad',
        direccion: 'right',
        propiedad: 'visible',
        tipo: CASILLA_ESTADO,
        estados: VISIBILIDADMOVIMIENTO
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]